import { HeaderOnlyHome } from '@/components/mobile/header-only-home'
import { createFileRoute, useRouter } from '@tanstack/react-router'
import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectCreative, Navigation } from 'swiper/modules';

import styles from './styles.module.scss'
//@ts-expect-error
import "swiper/css";
//@ts-expect-error
import 'swiper/css/effect-creative';
import { BottomSheet } from '@/components/mobile/bottom-sheet';
import { ModalLuck } from '@/components/ui/modal-luck';
import { ModalPayment } from '@/components/ui/modal-payment';
import { ConfirmedPayment } from '@/components/ui/confirmed_payment';
import { useCallback, useEffect, useState } from 'react';
import { cardsServiceInstance } from '@/services/cards.service';
import { transactionsServiceInstance, type CreateTransactionOutput } from '@/services/transaction.service';
import { io } from 'socket.io-client';
import { useBoolean, useCampaignContext } from '@/hooks';
import { useAtom } from 'jotai';
import { userAtom } from '@/store/atoms/user.atom';
import { ModalUseSaud } from '@/components/ui/modal-use-saud';
import { ChevronLeftCircle, ChevronRightCircle } from 'lucide-react';
import toast from 'react-hot-toast';

export const Route = createFileRoute('/mobile/buy-cards/')({
  component: RouteComponent,
  loader: async () => {
    const response = await cardsServiceInstance.pickForPurchase()

    return {
      cards: response
    }
  },
  shouldReload: true,
})

function RouteComponent() {
  const { cards: cardsData } = Route.useLoaderData()

  const { campaign } = useCampaignContext()
  const [cards, setCards] = useState(cardsData);
  const [selectedCards, setSelectedCards] = useState<typeof cardsData>([])
  const [currentTransaction, setCurrentTransaction] = useState<CreateTransactionOutput | undefined>(undefined)
  const [isOpenModalTransaction, handleOpenModalTransaction, handleClosemodalTransaction] = useBoolean()
  const [isOpenModalConfirmPayment] = useBoolean()
  const [isOpenModalLuck, handleOpenModalLuck, handleCloseModalLuck] = useBoolean()
  const [currentUser, setCurrentUser] = useAtom(userAtom)
  const router = useRouter()
  const [isOpenModalUseSaud, handleOpenModalUseSaud, handleCloseModalUseSaud] = useBoolean()


  useEffect(() => {
    const socket = io('https://sortelecadmdashboard.com', {
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 10,
      transports: ['websocket']
    })

    socket.on("lock-card", msg => {
      setCards(prev => prev.filter(card => card.id !== msg))
      setSelectedCards(prev => prev.filter(card => card.id !== msg))
    })

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        if (!socket?.active) {
          socket?.connect();
        }
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      socket.disconnect()
    }
  }, [])

  const handleUseSaud = useCallback(async () => {
    const pricing = selectedCards.length * campaign!.value
    if (currentUser!.wallet.amount < pricing) {
      toast.error("Saldo insuficiente. Remova uma ou mais cartelas do carrinho para continuar.")
      return
    }
    await transactionsServiceInstance.useSaud({
      cards: selectedCards.map(c => c.id)
    })

    // if (response.length > 0) {
    //   await createTransactionWhenUseSaud(response)
    //   handleCloseModalUseSaud()
    //   return
    // }
    handleCloseModalUseSaud()
    const value = selectedCards.length * campaign!.value
    // const wallet = await userServiceInstance.wallet()
    if (currentUser) {
      setCurrentUser({
        ...currentUser,
        wallet: {
          ...currentUser.wallet,
          amount: currentUser.wallet.amount - value
        }
      })
    }
    router.navigate({ to: '/mobile/game' })
  }, [currentUser, selectedCards, cards])

  // const createTransactionWhenUseSaud = useCallback(async (cards: string[]) => {
  //   const response = await transactionsServiceInstance.create({
  //     cards: cards
  //   })
  //   setCurrentTransaction(response)
  //   handleOpenModalTransaction()
  // }, [])

  const handleCreateTransaction = useCallback(async () => {
    const response = await transactionsServiceInstance.create({
      cards: selectedCards.map(c => c.id)
    })
    setCurrentTransaction(response)
    handleOpenModalTransaction()
  }, [selectedCards])

  const handleSelectCard = useCallback((cardId: string) => {
    const cardExists = selectedCards.find(c => c.id === cardId)
    if (cardExists) {
      setCards(prev => ([...prev, cardExists]))
      return setSelectedCards(prev => prev.filter(c => c.id !== cardId))
    }
    const card = cards.find(c => c.id === cardId)
    if (!card) return
    setSelectedCards(prev => [...prev, card])
    setCards(prev => prev.filter(c => c.id !== cardId))
  }, [cards, selectedCards])

  const refreshCards = useCallback(async () => {
    const cards = await cardsServiceInstance.pickForPurchase()
    setCards(cards)
    setSelectedCards([])
  }, [])

  const onConfirmLuck = useCallback((quantity: number) => {
    const selecteds = cards.slice(0, quantity)

    setCards(prev => prev.filter(c => !selecteds.find(card => card.id === c.id)))
    setSelectedCards(selecteds)
    handleCloseModalLuck()
  }, [cards])

  const removeCard = useCallback((cardId: string) => {
    const card = selectedCards.find(c => c.id === cardId)

    if (!card) return
    setCards(prev => ([...prev, card]))
    setSelectedCards(prev => prev.filter(c => c.id !== card.id))
  }, [selectedCards])

  if (!campaign) return null
  return (
    <div className={styles.container}>
      <HeaderOnlyHome />
      <div>
        <div className={styles.header}>
          <div>
            <img
              src="/assets/signboard.svg"
            />
            {
              selectedCards.length > 0 && (
                <span>{selectedCards.length}</span>
              )
            }
          </div>
          <h3>Selecione uma cartela</h3>
        </div>

        <div className={styles.container__swiper}>
          <button className='arrow-prev'>
            <ChevronLeftCircle size={26} />
          </button>
          <Swiper
            grabCursor={true}
            effect={'creative'}
            creativeEffect={{
              prev: {
                shadow: true,
                translate: [0, 0, -400],
              },
              next: {
                translate: ['100%', 0, 0],
              },
            }}
            navigation={{
              nextEl: '.arrow-next',
              prevEl: '.arrow-prev',
            }}
            modules={[EffectCreative, Navigation]}
            style={{ height: "322px" }}
          >
            {cards.map((slide) => (
              <SwiperSlide
                key={slide.id}
                style={{
                  width: '326px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div
                  className={styles.card}
                  onClick={() => handleSelectCard(slide.id)}
                >
                  <ul>
                    {
                      slide.cardBalls.map((c) => (
                        <li key={c}>
                          <span>{c}</span>
                        </li>
                      ))
                    }
                  </ul>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <button className='arrow-next'>
            <ChevronRightCircle size={26} />
          </button>
        </div>
        <footer className={styles.footer}>
          <button onClick={refreshCards}>
            <img src="/assets/update.png" />
          </button>
          <button onClick={handleOpenModalLuck}>
            <img src="/assets/auto_select.png" />
          </button>
        </footer>
      </div>

      <div>
        <div className={styles.header}>
          <img
            src="/assets/signboard.svg"
          />
          <h3>Suas cartelas</h3>
        </div>

        <div className={styles.my_cards}>
          {selectedCards.map((c) => (
            <div className={styles.my_card} key={c.id}>
              <button onClick={() => removeCard(c.id)}>
                <img
                  src="/assets/btn_close.png"
                  alt="Delete Card"
                  className={styles.delete_icon}
                />
              </button>
              <ul>
                {
                  c.cardBalls.map((number) => (
                    <li key={number}>
                      <span>{number}</span>
                    </li>
                  ))
                }
              </ul>
            </div>
          ))}
        </div>
      </div>
      {
        isOpenModalTransaction && currentTransaction && (
          <ModalPayment
            transaction={currentTransaction}
            onClose={handleClosemodalTransaction}
            onSuccess={() => {
              router.navigate({ to: '/mobile/game' })
            }}
          />
        )
      }
      {
        isOpenModalConfirmPayment && (
          <ConfirmedPayment />
        )
      }
      {
        selectedCards.length > 0 && (
          <BottomSheet
            quantityCards={selectedCards.length}
            handleCreateTransaction={async () => {

              if (currentUser?.wallet && currentUser?.wallet?.amount > 0) {
                if (currentUser?.wallet?.amount < selectedCards.length * campaign.value) {
                  toast.error("Saldo insuficiente. Remova uma ou mais cartelas do carrinho para continuar.")
                  return
                }
                handleOpenModalUseSaud()
                return
              }
              await handleCreateTransaction()
            }}
          />
        )
      }
      {
        isOpenModalLuck && (
          <ModalLuck
            onClose={handleCloseModalLuck}
            onConfirm={onConfirmLuck}
          />
        )
      }
      {
        isOpenModalUseSaud && (
          <ModalUseSaud
            transactionValue={selectedCards.length * campaign?.value}
            pay={handleUseSaud}
            onClose={handleCloseModalUseSaud}
          />
        )
      }
    </div>
  )
}
